import ReducerUtils   from "../../../utils/ReducerUtils"
import Actions        from "../../../model/constant/actions"

const RetrievingDecisions = ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_PACY_DECISIONS] : (state,action)=>action.status
})

export default RetrievingDecisions
